import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromEquipmentActivity from '../_reducers/equipmentActivity';

export const selectEquipmentActivityState =
  createFeatureSelector<fromEquipmentActivity.EquipmentActivityState>('equipmentActivities');

export const selectAllEquipmentActivities = createSelector(
  selectEquipmentActivityState,
  fromEquipmentActivity.selectAll
);

export const selectEquipmentActivityEntities = createSelector(
  selectEquipmentActivityState,
  fromEquipmentActivity.selectEntities
);

export const selectEquipmentActivityById = (id: number) =>
  createSelector(selectEquipmentActivityEntities, (entities) => entities[id]);

export const selectEquipmentActivityTotal = createSelector(
  selectEquipmentActivityState,
  fromEquipmentActivity.selectTotal
);
